/**
 * Returns base64 data URL for an external image using XMLHttpRequest.
 * @memberof utils
 */
export async function getBase64FromExternalImage(url) {
    return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var reader = new window.FileReader();
                reader.readAsDataURL(this.response);
                reader.onloadend = () => {
                    let base64data = reader.result;
                    resolve(base64data);
                };
            }
        };

        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    });
}

/**
 * To Avoid caching of logo image from AWS CDN
 */
export const changeLogoUrlToAWS = (logoUrl) => {
    if (logoUrl) {
        return logoUrl.replace(/^https:\/\/static\.lln\.training\//, 'https://s3.ap-southeast-2.amazonaws.com/static.lln.training/');
    }
    return logoUrl;
};

export const resizeImageFile = (file, targetWidth, targetHeight) =>
    new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = targetWidth;
            canvas.height = targetHeight;

            // SCALE TO COVER
            const scale = Math.max(targetWidth / img.width, targetHeight / img.height);

            const drawWidth = img.width * scale;
            const drawHeight = img.height * scale;

            // center the image, overflowing on 1 axis (cropped)
            const offsetX = (targetWidth - drawWidth) / 2;
            const offsetY = (targetHeight - drawHeight) / 2;

            // optional: clear canvas instead of white background
            ctx.clearRect(0, 0, targetWidth, targetHeight);
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        reject(new Error('Canvas is empty'));
                        return;
                    }

                    const resizedFile = new File([blob], file.name, {
                        type: file.type || 'image/png',
                        lastModified: Date.now()
                    });

                    resolve({
                        file: resizedFile,
                        url: URL.createObjectURL(resizedFile)
                    });
                },
                file.type || 'image/png',
                0.92
            );
        };

        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
